import styles from "./PageEdit.module.css"

// component
import TextInput from "./TextInput";
import ImageSelector from "./ImageSelector";

export default function PageHeaderEdit({sectionKey, title, text, imageUrl, updateField}) {

    return(
        <div className={styles.pageHeaderEdit}>
            
            <h1>{title}</h1>

            {/* Title Input */}
            <TextInput
                label={"Title"}
                value={title}
                onChange={(e) => updateField(sectionKey,"title", e.target.value)}
            />  
            
    
            {/* Content */}
            <TextInput
                label={"Tekst til header"}
                value={text}
                onChange={(e) => updateField(sectionKey,"text", e.target.value)}
            />
    
            {/* Image Upload */}
            <ImageSelector value={imageUrl} updateField={(val) => updateField(sectionKey,'imageUrl', val)} />
        </div>
    );

}